const style = {
  container: {
    position: "relative",
    display: "block",
    minHeight: "100vh",
    background: "#0d091b",
    "@media(max-width:767px)": {
      padding: "15px",
    },
    "@media(max-width:480px)": {
      paddingTop: "16px",
    },
    "& #Faqs": {
      marginBottom: "0",
    },
  },
  featuredSongsSection: {
    backgroundColor: "#0c091b",
    padding: "0 25px 60px",
    maxWidth: "1280px",
    margin: "40px auto 0",
    fontFamily: "'Inter',sans-serif !important",
  },
  featuredTitleH1: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    marginBottom: "26px",
    marginTop: "30px",
    // padding: "43px 28px 8px",
    "@media(max-width:767px)": {
      margin: "0px",
      fontSize: "24px",
      letterSpacing: "1px",
      fontWeight: "600",
    },
  },
  featuredHowitWorkTitle: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    marginBottom: "40px",
    // marginTop: "120px",
    "@media(max-width:480px)": {
      margin: "0px",
      fontSize: "24px",
      letterSpacing: "1px",
      fontWeight: "600",
      // marginTop: "120px",
    },
  },
  comparisonofReturnContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "1228px",
    margin: "auto",
    background: "#1A1728",
    borderRadius: "12px",
    "& img": {
      minHeight: "396px",
    },
  },
  comparisonofReturn: {
    textAlign: "center",
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "51px",
    marginBottom: "40px",
    marginTop: "40px",
    "@media(max-width:767px)": {
      margin: "0px",
      fontSize: "24px",
      letterSpacing: "1px",
      fontWeight: "600",
    },
  },
  featuredSongsBox: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "1280px",
    "@media (max-width:767px)": {
      width: "100%",
      maxWidth: "356px",
    },
  },
  featuredtargetReturns: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "1280px",
    "@media (max-width:767px)": {
      width: "100%",
      maxWidth: "356px",
    },
  },
  featuredRow: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "20px",
    "& .slick-slider": {
      width: "100%",
    },
    "& .slick-slider .slick-dots li": {
      margin: "0",
    },
    "& .slick-slider .slick-dots": {
      bottom: "0",
    },
    "& .slick-slider .slick-dots li button": {
      fontSize: "0",
    },
    "& .slick-slider .slick-dots li button:before": {
      content: "''",
      position: "relative",
      display: "inline-block",
      borderRadius: "50%",
      width: "8px",
      height: "8px",
      background: "#fff",
      opacity: "1",
    },
    "& .slick-slider .slick-dots li.slick-active button:before": {
      content: "''",
      position: "relative",
      display: "inline-block",
      fontSize: "10px",
      fontWeight: "600",
      background: "#E14084",
      borderRadius: "40px",
    },
  },
  featuredBox: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "33.33%",
    padding: "15px",
    "@media (max-width:480px)": {
      width: "100%",
      padding: "0px",
    },
  },
  featuredCard: {
    position: "relative",
    display: "block",
    width: "100%",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#19132A",
    marginBottom: "30px",
    "@media (max-width:480px)": {
      marginBottom: "40px",
    },
  },
  featuredCardImageBox: {
    position: "relative",
    display: "block",
    width: "100%",
    marginBottom: "15px",
    borderRadius: "10px",
    overflow: "hidden",
    lineHeight: "0",
  },
  featuredCardImage: {
    width: "100%",
    borderRadius: "10px 10px 0 0",
    height: "371px",
    objectFit: "cover",
    "@media (max-width:480px)": {
      height: "261px",
    },
  },
  featuredPlayIcon: {
    position: "absolute",
    left: "30px",
    bottom: "30px",
    width: "60px",
    height: "60px",
    filter: "drop-shadow(2px 2px 3px rgba(0,0,0,0.5))",
  },
  featuredCardContent: {
    position: "relative",
    display: "block",
    padding: "0 15px 15px",
  },
  featuredCardTitle: {
    fontWeight: "700",
    fontSize: "24px",
    color: "#fff",
    "@media (max-width:767px)": {
      fontSize: "20px",
    },
    "@media (max-width:480px)": {
      fontSize: "18px",
    },
  },
  featuredCardSubTitle: {
    fontWeight: "500",
    fontSize: "18px",
    color: "#fff",
    "& img": {
      margin: "0 5px",
    },
    "@media (max-width:480px)": {
      fontSize: "16px",
      fontWeight: "500",
    },
  },
  featuredCardSubTitlePrice: {
    fontWeight: "500",
    fontSize: "18px",
    color: "#fff",

    "@media (max-width:480px)": {
      fontSize: "18px",
      fontWeight: "700",
    },
  },
  featuredBasicCalculatorSubTitle: {
    fontWeight: "500",
    fontSize: "18px",
    color: "#fff",
    textAlign: "center",
    width: "100%",
    maxWidth: "694px",
    margin: " 0 auto 25px",
    display: "block",

    "@media (max-width:480px)": {
      fontSize: "14px",
      fontWeight: "500",
    },
  },
  featuredStats: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    marginTop: "12px",
  },
  featuredTokens: {
    textAlign: "right",
  },
  featuredBuyNow: {
    position: "relative",
    textAlign: "center",
    display: "inline-block",
    fontWeight: "600",
    fontSize: "16px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    marginTop: "20px",
    borderRadius: "12px !important",
    height: "44px",
    color: "#fff",
    width: "161px",
    marginLeft: "20px !important",
    marginTop: "12px !important",
    textDecoration: "none",
    cursor: "pointer",
    textTransform: "capitalize !important",
    "&:hover": {
      color: "#fff",
      textDecoration: "none",
    },
    "@media(max-width:992px)": {
      margin: "auto",
      marginTop: "30px",
    },
    "@media(max-width:480px)": {
      width: "50%",
      fontSize: "14px",
    },
  },
  featuredBuyOnMarketPlace: {
    position: "relative",
    textAlign: "center",
    display: "inline-block",
    fontWeight: "600",
    fontSize: "16px",
    width: "135px",
    border: "1px solid #fff !important",
    marginTop: "12px !important",
    borderRadius: "12px !important",
    height: "44px",
    color: "#fff !important",
    textTransform: "capitalize !important",
    "@media(max-width:480px)": {
      width: "50%",
      fontSize: "14px",
      padding: "5px",
    },
  },
  featuredBtnDisabled: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    width: "100%",
    background: "#bababa !important",
    marginTop: "20px",
    borderRadius: "10px",
    height: "56px",
    color: "#9C9C9C",
    textTransform: "capitalize",
  },
  featuredBottomText: {
    textAlign: "center",
    position: "relative",
    width: "100%",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    marginTop: "20px",
  },
  spotifyLogo: {
    width: "60px",
    marginLeft: "5px",
  },
  featuredBoxSingle: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "1280px",
    alignItems: "start",
    justifyContent: "center",
  },
  featuredCardImageBoxSingle: {
    width: "100%",
    maxWidth: "615px",
    borderRadius: "30px",
    overflow: "hidden",
    "& img": {
      width: "100%",
    },
  },
  featuredCardContentSingle: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "450px",
    "@media (max-width:930px)": {
      marginTop: "20px",
    },
  },
  btnLanguage: {
    position: "relative",
    display: "inline-block",
    padding: "4px 10px",
    color: "#fff",
    fontSize: "12px",
    borderRadius: "8px",
    marginBottom: "12px",
    background: "#534780",
  },
  btnRoyaltyShare: {
    position: "relative",
    display: "inline-block",
    padding: "4px 10px",
    color: "#fff",
    fontSize: "12px",
    borderRadius: "8px",
    marginLeft: "12px",
    marginBottom: "12px",
    background: "linear-gradient(90.78deg, #B237F6 3.91%, #E94177 96.03%)",
  },
  featuredSingleTitle: {
    position: "relative",
    display: "flex",
  },
  songNameContent: {
    "@media (max-width:930px)": {
      marginLeft: "-40px",
    },
  },
  songDate: {
    transform: "rotateZ(-90deg) translateX(-58px) translateY(-2px)",
    color: "#E14084",
    fontWeight: "700",
    display: "block",
    padding: "5px 0",
    borderBottom: "1px solid rgba(255, 255, 255, 0.5)",
    height: "30px",
    fontSize: "16px",
    textTransform: "uppercase",
    whiteSpace: "nowrap",

    "@media (max-width:930px)": {
      transform: "rotateZ(-90deg) translateX(-43px) translateY(-31px)",
    },
    "@media (max-width:767px)": {
      fontSize: "10px",
      fontWeight: "600",
      transform: "rotateZ(-90deg) translateX(-27px) translateY(-33px)",
      height: "25px",
    },
  },
  songName: {
    color: "#fff",
    fontSize: "42px",
    fontWeight: "700",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
      color: "#fff",
    },
    "@media (max-width:480px)": {
      fontSize: "28px",
    },
  },
  singerName: {
    display: "flex",
    color: "#fff",
    alignItems: "center",
    marginTop: "15px",
    "& img": {
      width: "39px",
      height: "39px",
      objectFit: "cover",
      borderRadius: "50%",
    },
    "& small": {
      padding: "0 5px",
      fontSize: "24px",
      fontWeight: "600",
    },
    "@media (max-width:480px)": {
      marginTop: "0",
      "& img": {
        width: "24px",
        height: "24px",
      },
      "& small": {
        fontSize: "16px",
      },
    },
  },
  songDescription: {
    color: "#fff",
    fontSize: "14px",
    textAlign: "justify",
  },
  songDetails: {
    paddingLeft: "45px",
    marginTop: "30px",
    "& span": {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      marginTop: "20px",
      display: "block",
    },
    "@media (max-width:930px)": {
      paddingLeft: "0",
    },
  },
  countDown: {
    fontSize: "45px",
    color: "#fff",
    fontWeight: "600",
    "& span": {
      fontSize: "45px",
    },
  },
  tableCount: {
    marginLeft: "-18px",
    width: "100%",
    maxWidth: "400px",
    "& td": {
      padding: "16px 16px 16px 0",
      borderBottom: "none",
      width: "50px",
    },
    "& td h3": {
      fontWeight: "500",
    },
    "@media (max-width:930px)": {
      marginLeft: "0",
    },
  },
  counterLine: {
    position: "relative",
    display: "block",
    width: "60px",
    borderRadius: "10px",
    height: "7px",
    background: "#E14084",
  },
  buttonSet: {
    display: "flex",
    justifyContent: "space-between",
    "& button": {
      margin: "35px 1px 0",
      // width:"auto",
      padding: "0 20px",
    },
    "& button:nth-of-type(2)": {
      width: "250px",
    },
  },
  watchSection: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "1170px",
    padding: "0 15px",
    justifyContent: "center",
    margin: "60px auto",
    "& .slick-slider": {
      width: "100%",
    },
  },
  watchBox: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "0 15px",
    marginBottom: "30px",
    cursor: "pointer",
    "@media(max-width:480px)": {
      maxWidth: "100%",
    },
  },
  videoBgContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "390px",
    maxHeight: "243px",
    margin: "0 auto 30px",
    borderRadius: "20px",
    overflow: "hidden",
    "& img": {
      width: "100%",
    },
  },
  mediaTitle: {
    color: "#E14084",
    fontSize: "16px",
    fontWeight: "600",
  },
  newsTitle: {
    cursor: "pointer",
    fontSize: "18px",
    fontWeight: "700",
    color: "#FFF",
    marginTop: "15px",
    marginBottom: "24px",
  },
  newsLink: {
    position: "relative",
    display: "inline-block",
    color: "#E14084",
    fontSize: "16px",
    fontWeight: "500",
    padding: "0 3px",
    borderBottom: "1px solid #E14084",
  },
  header: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    padding: "20px 72px",
    borderBottom: "1px solid #ccc",
    justifyContent: "space-between",
    "& img": {
      width: "180px",
    },
    "@media(max-width:767px)": {
      padding: "20px",
      "& img": {
        width: "160px",
      },
    },
  },
  menu: {
    "& a": {
      position: "relative",
      display: "inline-block",
      padding: "4px 28px",
      color: "#fff",
      fontSize: "16px",
      fontWeight: "600",
    },
    "& a:last-child": {
      position: "relative",
      display: "inline-block",
      padding: "4px 10px",
      color: "#000",
      marginLeft: "20px",
      background: "#fff",
      borderRadius: "10px",
    },
    "@media(max-width:767px)": {
      display: "none",
    },
  },
  headerContainer: {
    position: "relative",
    display: "block",
    minHeight: "600px",
    // background: "center/cover no-repeat url(/images/sem/header-banner.png)",
  },
  topSectionContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    padding: "55px 72px",
    margin: "auto",
    alignItems: "center",
    justifyContent: "center",
    "& .slick-slider": {
      maxWidth: "522px",
      borderRadius: "24px",
    },
    "& .slick-slider .slick-disabled": {
      opacity: "0.5",
    },
    "& .slick-list": {
      padding: "30px 0",
    },
    "& .slick-slider .slick-prev:before, & .slick-slider button.slick-prev": {
      content: "''",
      width: "36px",
      height: "36px",
      background: "center/contain no-repeat url(/images/sem/prev.svg)",
      left: "initial",
      right: "60px",
      top: "initial",
      bottom: "-30px",
      zIndex: "1",
    },
    "& .slick-slider .slick-next:before, & .slick-slider button.slick-next": {
      content: "''",
      width: "36px",
      height: "36px",
      background: "center/contain no-repeat url(/images/sem/next.svg)",
      right: "10px",
      top: "initial",
      bottom: "-30px",
      zIndex: "1",
    },
    "& .slick-slider .slick-dots li": {
      margin: "0",
    },
    "& .slick-slider .slick-dots": {
      bottom: "0",
    },
    "& .slick-slider .slick-dots li span": {
      fontSize: "0",
    },
    "& .slick-slider .slick-dots li span:before": {
      content: "''",
      position: "relative",
      display: "inline-block",
      borderRadius: "50%",
      width: "8px",
      height: "8px",
      background: "#fff",
      opacity: "1",
    },
    "& .slick-slider .slick-dots li.slick-active span": {
      content: "''",
      position: "relative",
      display: "inline-block",
      fontSize: "10px",
      fontWeight: "600",
      background: "#E14084",
      borderRadius: "40px",
      width: "initial",
      height: "initial",
      padding: "0 3px",
      color: "#fff",
      opacity: "1",
    },
    "& .slick-slider .slick-dots li.slick-active span:before": {
      display: "none",
    },
    "@media(max-width:480px)": {
      padding: "20px 0 40px",
    },
  },
  bannerContent: {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: "1280px",
    margin: "auto",
    alignItems: "center",
    padding: "0px 0",
    textAlign: "center",
    "& > a": {
      color: "#fff",
      margin: "12px 0",
      fontWeight: "700",
      fontSize: "16px",
      position: "relative",
      display: "block",
      width: "100%",
      textDecoration: "underline",
    },
    "@media (max-width:992px)": {
      width: "85%",
      marginTop: "30px",
    },
    "@media (max-width:767px)": {
      width: "100%",
      margin: "auto",
    },
    "@media (max-width:480px)": {
      width: "100%",
    },
  },
  bannerImageContainer: {
    width: "45%",
    "@media(max-width:767px)": {
      width: "100%",
      padding: "0",
    },
    textAlign: "center",
  },
  investmentBox: {
    position: "relative",
    display: "block",
    background: "#fff",
    backdropFilter: "blur(74px)",
    borderRadius: "24px",
    padding: "20px 12px 40px",
    width: "100%",
    maxWidth: "356px",
    margin: "auto",
    textAlign: "center",
    "& h3": {
      color: "#1D2D3F",
      fontSize: "30px",
      fontWeight: "700",
      marginBottom: "12px",
    },
    "& p": {
      color: "#000",
      fontSize: "14px",
      fontWeight: "400",
      marginBottom: "24px",
    },
    "& span": {
      color: "rgba(0, 0, 0, 0.54)",
      fontSize: "12px",
      fontWeight: "500",
      marginBottom: "24px",
    },
    "& input": {
      position: "relative",
      display: "block",
      background: "#fff",
      width: "100%",
      maxWidth: "288px",
      padding: "15px",
      margin: "auto",
      borderRadius: "8px",
      marginBottom: "18px",
      border: "1px solid rgba(0, 0, 0, 0.54)",
    },
    "& button": {
      position: "relative",
      textAlign: "center",
      display: "block",
      fontWeight: "600",
      width: "100%",
      maxWidth: "288px",
      margin: "auto",
      boxShadow: "none",
      background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
      marginTop: "20px",
      marginBottom: "27px",
      borderRadius: "10px",
      border: "none",
      height: "56px",
      color: "#fff",
      textDecoration: "none",
      cursor: "pointer",
      textTransform: "capitalize",
      // "&:hover": {
      //   color: "#fff",
      //   textDecoration: "none",
      //   boxShadow: "none",
      // },
      "@media(max-width:992px)": {
        margin: "auto",
        marginTop: "30px",
      },
    },
    "& button:last-child": {
      position: "absolute",
      textAlign: "center",
      display: "block",
      fontWeight: "600",
      width: "100%",
      border: "1px solid #E14084",
      bottom: "-56px",
      left: "50%",
      transform: "translateX(-50%)",
      background: "#fff",
      borderRadius: "8px",
      fontSize: "18px",
      fontWeight: "500",
      height: "56px",
      color: "#E14084",
      textTransform: "capitalize",
      "@media(max-width:480px)": {
        bottom: "-25px",
      },
    },
    "& hr": {
      position: "relative",
      display: "block",
      background: "#fff",
      width: "100%",
      maxWidth: "192px",
      margin: "auto",
      marginBottom: "26px",
    },
    "@media(max-width:767px)": {
      // maxWidth: "315px",
      display: "none",
    },
  },
  bannerTitle: {
    position: "relative",
    display: "block",
    width: "100%",
    marginBottom: "0",
    margin: "auto",
    fontWeight: "800",
    color: "#FFFFFF",
    fontSize: "54px",
    "@media(max-width:767px)": {
      fontSize: "40px",
    },
    "@media(max-width:480px)": {
      fontSize: "24px !important",
    },
  },
  bannerDescription: {
    color: "#fff",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "30px",
    marginBottom: "20px",
    "@media(max-width:767px)": {
      margin: "0px",
      fontSize: "14px",
      letterSpacing: "1px",
      fontWeight: "400",
      lineHeight: "24px",
    },
  },
  sliderBox: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "30px 48px 18px",
    height: "157px",
    background: "#f8c8dc",
    borderRadius: "24px",
    "@media(max-width:480px)": {
      // height: "184px",
      height: "100%",
    },
    "& h3": {
      margin: "0px",
      fontSize: "24px",
      fontWeight: "600",
    },
    "& p": {
      margin: "0px",
      fontSize: "18px",
      fontWeight: "400",
    },
    "& img.icon-1-css": {
      position: "absolute",
      top: "-35px",
      right: "-20px",
      width: "125px",
      "@media(max-width:767px)": {
        width: "123px",
        height: "80px",
      },
    },
    "& img.icon-2-css": {
      position: "absolute",
      top: "-40px",
      left: "-25px",
      width: "90px",
      "@media(max-width:767px)": {
        width: "123px",
        height: "80px",
      },
    },
    "& img.icon-3-css": {
      position: "absolute",
      top: "-35px",
      right: "-20px",
      "@media(max-width:767px)": {
        width: "123px",
        height: "80px",
      },
    },
  },
  featuredCardTitle1: {
    fontWeight: "400",
    fontSize: "16px !important",
    color: "#fff",
  },
  nftModalbox: {
    width: "360px",
    height: "360px",
    background: "#FFFFFF",
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "12px",
    padding: "25px 15px",
    "& h5": {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "24px",
      textAlign: "center",
    },
  },

  silvernftCard: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    background: "#F5F5F5",
    minWidth: "80px",
    padding: "15px",
    marginBottom: "20px",
    lineHeight: "28px",
    zIndex: "2",
    "&:before": {
      content: "''",
      position: "absolute",
      top: "2px ",
      left: "0",
      width: "100%",
      zIndex: "-2",
      height: "100%",
      background:
        "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
      borderRadius: "10px",
      border: "1px solid rgba(0, 0, 0, 0.1)",
    },
    "&:after": {
      content: "''",
      position: "absolute",
      top: "0 ",
      left: "0",
      width: "100%",
      zIndex: "-1",
      height: "100%",
      background: "#fff",
      borderRadius: "10px",
      border: "1px solid rgba(0, 0, 0, 0.1)",
    },
    "& h3": {
      fontSize: "16px",
      fontWeight: "600",
    },
    "& span": {
      fontSize: "12px",
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.75)",
    },
    "& h4": {
      fontSize: "14px",
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.9)",
      display: "flex",
    },
    "& small": {
      position: "absolute",
      top: "0",
      right: "0",
      width: "60px",
      height: "15px",
      fontSize: "10px",
      fontWeight: "600",
      textAlign: "center",
      borderRadius: "0 8px",
      background:
        "linear-gradient(90deg, #F2F2F2 2.67%, #FCFCFC 54.38%, #F3F3F3 87.97%)",
    },
  },
  titleBox: {
    display: "block",
    position: "relative",
    width: "80%",
  },
  packagePrice: {
    fontSize: "14px",
    fontWeight: "400",
    whiteSpace: "nowrap",
    color: "#ffff",
  },
  headerItems: {
    padding: "40px 15px 0",
    background: "#19132A",
    position: "relative",
    display: "flex",
    "@media(max-width:767px)": {
      flexWrap: "wrap",
      justifyContent: "center",
    },
  },
  title: {
    fontColor: "#FFF",
    fontFamily: "Ubuntu",
    color: "#FFF",
    fontWeight: 500,
    fontSize: "20px",
    textAlign: "left",
    paddingTop: "5px",
    paddingInline: "15px",
  },
  whatsAppDesktop: {
    position: "fixed",
    right: "0px",
    bottom: "0px",
    width: "100%",
    maxWidth: "430px",
    marginTop: "-30px",
    height: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    color: "#fff",
    padding: "10px 15px",
    cursor: "pointer ",
    zIndex: "100 ",
    background: "#1e1b3d",
    "& img": {
      marginRight: "12px",
    },
    "@media(max-width:767px)": {
      "& span": {
        display: "none",
      },
      "& img": {
        width: "24px !important",
        height: "24px !important",
      },
    },
  },
  returnCalculator: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "36px",
    color: "#fff  ",
    minWidth: "161px",
    borderRadius: "10px",
    border: "1px solid white",
    height: "43px",
    textDecoration: "none",
    textTransform: "capitalize",
  },
  btnConfirm: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    height: "43px",
    fontSize: "16px",
    minWidth: "161px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB) ",
    borderRadius: "10px",
    color: "#fff",
    textDecoration: "none",
    textTransform: "capitalize",
  },
  singerNamecss: {
    display: "flex",
    color: "#fff",
    alignItems: "center",
    marginTop: "15px",
    "& img": {
      width: "40px",
      height: "40px",
      objectFit: "cover",
      borderRadius: "50%",
    },
    "& small": {
      padding: "0 5px",
      fontSize: "16px",
      fontWeight: "500",
    },
    "@media (max-width:480px)": {
      marginTop: "0",
      "& img": {
        width: "24px",
        height: "24px",
      },
      "& small": {
        fontSize: "16px",
      },
    },
  },
  enquirenowandBuyNowbtn: {
    position: "relative",
    display: "flex",
    width: "100%",
    maxWidth: "522px",
    justifyContent: "space-between",
  },
  enquirenowandBuyNowbtnQ: {
    position: "relative",
    display: "flex",
    width: "100%",
    maxWidth: "522px",
    justifyContent: "space-between",
    "@media (max-width:480px)": {
      display: "block",
      "& button": {
        marginBottom: "16px",
      },
    },
  },
  bannerSubTitle: {
    color: "#0C091B",
    background:
      "linear-gradient(45deg, rgba(225, 64, 132, 1) 0%, rgba(52, 84, 250, 1) 47%, rgba(84, 181, 187, 1) 80%) !important",
    WebkitBackgroundClip: "text !important",
    WebkitTextStroke: "3px transparent",
    fontWeight: "700 !important",
    fontSize: "54px !important",
    position: "relative !important",
    display: "block !important",
    width: "100% !important",
    "@media(max-width:767px)": {
      fontSize: "24px !important",
    },
    paddingTop: "5px",
    paddingBottom: "0",
    marginBottom: {
      tablet: "0",
      mobile: "0",
    },
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    "@media(max-width:480px)": {
      padding: "5px 15px 0",
      fontSize: "24px",
      WebkitTextStroke: "3px transparent",
      letterSpacing: "0.05em",
    },
  },
  topheaderVideos: {
    position: "relative",
    width: "100%",
    maxWidth: "1044px",
    display: "flex",
    justifyContent: "center",
    borderRadius: "6px 6px 0px 0px",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
  },
  topsectionAskquestion: {
    position: "relative",
    display: "block",
    color: "#fff",
    width: "100%",
    minHeight: "90px",
    maxWidth: "1240px",
    padding: "2px",
    margin: "0 auto 30px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    borderRadius: "12px",
    "& > div": {
      position: "relative",
      display: "flex",
      minHeight: "90px",
      padding: "0 80px",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      borderRadius: "12px",
      background: "#0d091b",
      "@media(max-width:480px)": {
        display: "block",
        padding: "40px 15px",
        textAlign: "center",
        borderRadius: "0px",
      },
    },
    "& > div > span": {
      padding: "10px 0",
      display: "block",
    },
    "@media(max-width:480px)": {
      margin: "0 -18px 30px",
      borderRadius: "0px",
      padding: "2px 0px",
      width: "initial",
    },
  },
  whtsNFTquestionbtn: {
    position: "relative",
    textAlign: "center",
    display: "inline-block",
    fontWeight: "600",
    fontSize: "16px",
    width: "241px",
    border: "1px solid #fff !important",
    borderRadius: "12px !important",
    background: "#E14084",
    height: "50px",
    color: "#fff !important",
    textTransform: "capitalize !important",
    " & hover": {
      // backgroundColor: "none",
    },
    "@media(max-width:480px)": {
      fontSize: "14px",
    },
  },
  questioncontainer: {
    position: "relative",
    display: "block",
    marginBottom: "40px",
    "& span:last-child": {
      border: "none",
    },
  },
  whtsNFTquestion: {
    margin: "0",
    color: "#fff!important",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: "600",
    fontSize: "12px",
    width: "100%",
    textTransform: "capitalize!important",
    padding: "12px 0",
    borderBottom: "1px solid #5F5D69",
    cursor: "pointer",
  },
  howdoMakemoney: {
    position: "relative",
    textAlign: "center",
    display: "inline-block",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "37px",
    width: "241px",
    border: "1px solid #fff !important",
    borderRadius: "12px !important",
    height: "50px",
    color: "#fff !important",
    textTransform: "capitalize !important",
    "@media(max-width:480px)": {
      fontSize: "14px",
    },
  },
  popoverDropdown: {
    "& .MuiPopover-paper": {
      background: "#19132A",
      width: "100%",
      maxWidth: "310px",
      color: "#fff",
      border: "1px solid rgba(255, 255, 255, 0.5)",
      borderRadius: "8px",
      padding: "15px",
      paddingRight: "45px",
      maxHeight: "240px",
      overflow: "auto",
    },
    "& hr": {
      margin: "10px 0",
      borderBottom: "1px solid rgba(255, 255, 255, 0.5)",
    },
  },
  listItemDropdown: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
    "& img:first-of-type": {
      width: "48px",
      height: "48px",
      borderRadius: "8px",
      marginRight: "13px",
    },
    "& div": {
      position: "relative",
      display: "block",
      width: "100%",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "700",
    },
    "& small": {
      fontSize: "12px",
      fontWeight: "400",
    },
  },
  songDropdown: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    // marginTop: "30px",
    width: "100%",
    maxWidth: "481px",
    height: "72px",
    marginBottom: "30px",
    padding: "12px",
    border: "1px solid rgba(255, 255, 255, 0.5)",
    borderRadius: "8px",
    color: "#fff",
    "& img:first-of-type": {
      width: "48px",
      height: "48px",
      borderRadius: "8px",
      marginRight: "13px",
    },
    "& div": {
      position: "relative",
      display: "block",
      width: "100%",
      lineHeight: "10px",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "700",
      lineHeight: "10px",
    },
    "& small": {
      fontSize: "12px",
      fontWeight: "400",
    },
  },
  rangeSliderBox: {
    width: "100%",
    maxWidth: "400px",
    position: "relative",
    display: "block",
    margin: "0 auto 15px",
    borderRadius: "10px",
    padding: "10px 0",
    "& .MuiSlider-thumb": {
      background: "#fff",
      borderRadius: "4px",
      minWidth: "20px",
      height: "20px",
      color: "#000",
      "&:after": {
        display: "none !important",
      },
      "&:hover": {
        boxShadow: "none",
      },
    },
    "& .MuiSlider-root": {
      height: "2px",
      marginBottom: "0",
    },
    "& .MuiSlider-track": {
      background: "#E94177",
      border: "none",
    },
    "& .MuiSlider-rail": {
      background: "#fff",
    },
    "& .MuiSlider-valueLabel": {
      top: "0",
      color: "#fff",
      padding: "0 7px",
      height: "36px",
      minWidth: "72px",
      borderRadius: "8px",
      fontSize: "10px",
      background:
        "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
      position: "relative",
      transform: "none !important",
      "&:before": {
        display: "none",
      },
    },
    "& .MuiSlider-markLabel": {
      color: "rgba(255, 255, 255, 0.7)",
      fontSize: "10px",
      top: "19px",
    },
  },
  content: {
    fontSize: "14px",
    fontWeight: "400",
    marginBottom: "16px",
    marginLeft: "-26px",
    color: "#fff",
    "@media(max-width:480px)": {
      marginLeft: "-2px",
    },
  },
  nftcardDetailsforSong: {
    width: "100%",
    maxWidth: "473px",
    borderRadius: "12px",
    "& li": {
      position: "relative",
      display: "block",
      width: "100%",
      height: "99px",
      padding: "12px",
      borderRadius: "12px",
      cursor: "pointer",
      marginBottom: "24px",
      "& > small": {
        color: "#fff",
        fontSize: "24px",
        fontWeight: "800",
      },
      "&.active": {
        border: "1px solid rgba(255, 255, 255, 0.5)",
        "@media(max-width:480px)": {
          border: "1px solid red",
        },
      },
    },
    "& li.silver": {
      background: "center / cover no-repeat url(/images/calculator/silver.jpg)",
    },
    "& li.gold": {
      background: "center / cover no-repeat url(/images/calculator/gold.jpg)",
    },
    "& li.platinum": {
      background:
        "center / cover no-repeat url(/images/calculator/platinum-new.svg)",
    },
    "@media(max-width:480px)": {
      display: "flex",
      "& li": {
        margin: "1px",
        "& > small": {
          fontSize: "16px !important",
          fontWeight: "900 !important",
        },
      },
    },
  },
  returnCalculatorShow: {
    display: "flex",
    justifyContent: "space-between",
    maxWidth: "998px",
    margin: "auto",
    "@media(max-width:480px)": {
      flexWrap: "wrap",
    },
  },
  basicReturnCalculatorShow: {
    position: "relative",
    display: "block",
    padding: "30px 70px",
    width: "100%",
    maxWidth: "594px",
    background: "#242033",
    borderRadius: "10px",
    "@media(max-width:480px)": {
      padding: "30px 15px",
    },
  },
  secondCalculatorShow: {
    width: "100%",
    maxWidth: "387px",
    background: "#242033",
    borderRadius: "10px",
    "@media(max-width:480px)": {
      display: "none",
    },
  },
  lineSeparator: {
    position: "relative",
    display: "block",
    width: "100%",
    margin: "15px 0",
    borderBottom: "1px solid #fff",
    opacity: "0.5",
  },
  donutChart: {
    position: "relative",
    display: "block",
    padding: "40px 13px 28px",
  },
  graphContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& span": {
      color: "rgba(255, 255, 255, 0.5)",
      fontSize: "14px",
      fontWeight: "400",
      padding: "0 25px",
      position: "relative",
    },
    "& span:before": {
      content: "''",
      position: "absolute",
      width: "12px",
      height: "12px",
      borderRadius: "4px",
      left: "6px",
      top: "4px",
    },
    "& span:first-child:before": {
      background:
        "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    },
    "& span:last-child:before": {
      background: "#fff",
    },
  },
  roylatiyandNFTPrice: {
    color: "#ffff",
    "& h4": {
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "16px",
    },
    "& small": {
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "16px",
    },
    "& .MuiRadio-root": {
      position: "absolute",
      right: "20px",
      top: "50%",
      transform: "translateY(-50%)",
    },
    "@media(max-width:480px)": {
      "& h4": {
        fontWeight: "800",
        fontSize: "12px",
      },
      "& small": {
        fontWeight: "500",
        fontSize: "10px",
      },
      "& .MuiRadio-root": {
        display: "none",
      },
    },
  },

  modalContainer: {
    position: "relative",
    display: "block",
    maxWidth: "400px",
    margin: "0 15px",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%)translateX(-50%)",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#0C091B",
    "@media(max-width:480px)": {
      overflow: "auto",
      margin: "0 5px !important",
    },
  },
  modalHeader: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px",
    "&:after": {
      content: "''",
      position: "absolute",
      left: "0",
      right: "0",
      bottom: "0",
      height: "3px",
      background:
        "linear-gradient(45deg, rgba(225, 64, 132, 1) 0%, rgba(52, 84, 250, 1) 47%, rgba(84, 181, 187, 1) 80%)",
    },
  },
  modalTitle: {
    fontSize: "1.5rem",
    color: "#fff",
    fontWeight: "600",
    "@media(max-width:480px)": {
      fontSize: "1.3rem",
    },
  },
  modalBody: {
    position: "relative",
    display: "block",
    padding: "25px",
    background: "#fff",

    "@media(max-width:480px)": {
      maxHeight: "300px",
      overflow: "auto",
    },
  },
  modalListContent: {
    padding: "0 20px",
    "& li": {
      marginBottom: "15px",
      padding: "0 0 0 10px",
      listStyleType: "decimal",
      display: "list-item",
      "&::marker": {
        color: "#fff",
      },
    },
    "& li p": {
      color: "#fff",
      margin: "0",
      fontSize: "14px",
    },
  },
  videoBg: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "1044px",
    margin: "0 auto 30px",
    padding: "30px",
    background: "center/cover no-repeat url(/images/landing/video-bg.jpg)",
    borderRadius: "20px",
    "& video": {
      width: "100%",
      // height: "484px",
      transform: "inherit",
      // "@media(max-width:480px)": {
      //   // "@media(max-width:480px)": {
      //   // height: "163px",
      //   //   height: "163px",
      // },
      // },
    },
    "@media(max-width:480px)": {
      padding: "10px",
      borderRadius: "12px",
      lineHeight: "0px",
    },
  },
  investBox: {
    width: "33.33%",
    padding: "0px 28px",
    "@media(max-width:480px)": {
      width: "100%",
      marginBottom: "20px",
    },
  },
  investContentBox: {
    position: "relative",
    display: "block",
    width: "100%",
    borderRadius: "10px",
    background: "rgba(196, 196, 196, 0.077)",
    border: "7px solid rgba(255, 255, 255, 0.03)",
    padding: "20px",
    "& img": {
      marginBottom: "20px",
    },
    "& p": {
      fontSize: "16px",
      fontWeight: "500",
      color: "#fff",
    },
  },
  streamCount: {
    textAlign: "center",
    margin: "10px 0 0",
    width: "100%",
    display: "block",
    fontSize: "16px",
    color: "#fff",
  },
  checkMoreDetails: {
    color: "#E14084",
    border: "1px solid #fff",
    position: "relative",
    display: "block",
    width: "344px",
    padding: "10.5px 73px",
    border: "1px solid #fff",
    borderRadius: "8px",
    left: "25px",
    marginTop: "72px",
  },
  myReturns: {
    position: "relative",
    display: "none",
    "& p:first-child": {
      display: "block",
      fontSize: "14px",
      fontWeight: "500",
      color: "#fff",
      textAlign: "center",
      marginTop: "40px",
      marginBottom: "8px",
    },
    "& p:last-of-type": {
      display: "block",
      fontSize: "20px",
      fontWeight: "700",
      color: "#fff",
      textAlign: "center",
      marginBottom: "14px",
    },
    "& a": {
      display: "block",
      fontSize: "10px",
      fontWeight: "600",
      color: "#E14084",
      textAlign: "center",
    },
    "@media(max-width:480px)": {
      display: "block",
    },
  },
  formGroup: {
    position: "relative",
    position: "relative",
    display: "block",
    display: "block",
    width: "100%",
    width: "100%",
    marginBottom: "20px",
    marginBottom: "20px",
    "& select": {
      position: "relative",
      display: "block",
      marginLeft: "38px",
      width: "92.5%",
      height: "55px",
      fontSize: "14px",
      background: "transparent !important",
      color: "rgba(255, 255, 255, 0.75)",
      borderRadius: "12px",
      border: "1px solid rgba(255, 255, 255, 0.75)",
      padding: "16px 15px",
      "@media(max-width:480px)": {
        width: "83%",
      },
    },
    "& p": {
      position: "relative",
      display: "block",
      width: "100%",
      paddingLeft: "37px",
      marginBottom: "12px",
      "@media(max-width:480px)": {
        fontSize: "14px",
      },
    },
  },
  formContainer: {
    position: "relative",
    display: "block",
    maxHeight: "400px",
    overflow: "auto",
    overflowX: "hidden",
    paddingRight: "25px",
    "&::-webkit-scrollbar": {
      background: "#151125",
      borderRadius: "20px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#373444",
    },
    "@media(max-width:480px)": {
      maxHeight: "350px",
      paddingRight: "35px",
    },
  },
  inputField: {
    position: "relative",
    width: "100%",
    fontSize: "14px",
    background: "transparent !important",
    height: "90px",
    color: "rgba(255, 255, 255, 0.75)",
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.75)",
    padding: "16px 15px",
    "& option": {
      color: "initial",
      fontWeight: "400",
    },
    "& input": {
      background: "transparent !important",
      color: "#FFF",
      border: 0,
    },
    "& .PhoneInputInput": {
      "&:focus-visible": {
        outline: "none",
      },
    },
  },
  modalreactionContainer: {
    position: "relative",
    display: "block",
    maxWidth: "460px",
    margin: "0 15px",
    top: "50%",
    left: "50%",
    textOverflow: "ellipsis",
    transform: "translateY(-50%)translateX(-50%)",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#fff",
    "@media(max-width:480px)": {
      overflow: "auto",
      margin: "0 5px !important",
    },
  },
  modalreactionTitle: {
    fontSize: "18px ",
    color: "#0C091B",
    fontWeight: "600",
    "@media(max-width:480px)": {
      fontSize: "16px",
    },
  },

  okeybtnCSS: {
    textAlign: "center !important",
    fontWeight: "600",
    width: "100%",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    borderRadius: "12px",
    height: "44px",
    color: "#fff",
    textDecoration: "none",
    textTransform: "capitalize",
    marginBottom: "10px",
    display: "block",
    position: "relative",
    maxWidth: "85%",
    margin: "0 auto 11px",
  },
  btnClose: {
    position: "absolute !important",
    display: "inline-block !important",
    top: "10px !important",
    right: "10px !important",
    cursor: "pointer !important",
  },
};

export default style;
